import { Icon } from '@/shared/ui/Icon'
import type { ModelInfo } from '../types'

interface Props {
  model: ModelInfo
}

export function ModelCard({ model }: Props) {
  return (
    <div className="model-card">
      <div className="model-mark">
        <Icon name="flask" />
      </div>
      <h3 className="model-name">
        {model.name} <em>{model.emphasis}</em>
      </h3>
      <span className="model-version">
        {model.version} · {model.contextWindow}
      </span>
      <p className="model-desc">{model.description}</p>
    </div>
  )
}
